import React from 'react';
import { StyleSheet, ViewProps } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, BoxProps, Image, TouchableBox } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

export type LaunchpadTileProps = {
    onLayout?: ViewProps['onLayout'];
    isLastItem?: boolean;
    icon?: string | React.JSX.Element;
    subLabel?: string | React.JSX.Element;
    onPress?: () => void;
    testID?: string;
    disabled?: boolean;
    selected?: boolean;
    isLive?: boolean;
    label: string;
    paddingTop?: BoxProps['paddingTop'];
};

export const LaunchpadTile = ({
    label,
    icon,
    selected,
    onPress,
    disabled,
    isLive,
    onLayout,
    isLastItem,
    paddingTop = 's16',
    testID,
}: LaunchpadTileProps) => {
    return (
        <TouchableBox
            paddingLeft="s16"
            paddingRight={isLastItem ? 's16' : 's0'}
            onLayout={onLayout}
            alignItems={'center'}
            onPress={onPress}
            gap={'s8'}
            opacity={disabled ? 0.3 : 1}
            disabled={disabled}
            paddingTop={paddingTop}
            testID={testID}
        >
            {isLive ? (
                <Box
                    position={'absolute'}
                    width={10}
                    height={10}
                    backgroundColor={ds.colorToken.background.danger.strong}
                    borderRadius={'r10'}
                    top={15}
                    zIndex={1}
                    right={0}
                />
            ) : null}
            <Box
                width={45}
                height={45}
                justifyContent={'center'}
                alignItems={'center'}
                backgroundColor={
                    selected ? ds.colorToken.background.neutral.subtle : ds.colorToken.background.neutral.subtler
                }
                style={[styles.logoContainer, selected ? styles.selectedLogoContainer : {}]}
                borderWidth={1}
            >
                {typeof icon === 'string' ? (
                    <Image source={{ uri: icon }} style={styles.logo} resizeMode={'contain'} />
                ) : (
                    icon
                )}
            </Box>
            <Text variant="labelLarge" color={selected ? ds.colorToken.text.primary : 'neutral300'}>
                {label}
            </Text>
        </TouchableBox>
    );
};

const styles = StyleSheet.create({
    logo: {
        width: 22,
        height: 22,
    },
    logoContainer: {
        borderRadius: 13,
        borderCurve: 'continuous',
        borderColor: ds.colorValue.border.subtle,
    },
    selectedLogoContainer: {
        borderColor: ds.colorValue.border.subtle,
    },
});
